<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">支持的平台</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">最低系统要求</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">设置新节点</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">创世种子</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">添加种子节点</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">客户端使用</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">{{$t('m.Compliance')}}</a></p>
            <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">Support for Private Blockchains</a></p>
            <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Separation of Concerns</a></p>
            <p @click="activeted(5)" class="s2"><a :class="{active:flag==5}" href="#box5">Application-Specific Requirements</a></p>
    
          </div> -->
        </div>
      </div>
      <div class="p1">加入测试网</div>
      <div id="box1" class="p2">支持的平台</div>
      <div class="p3">我们支持在和完整节点系统。MacOSX， Windows ，Linux。</div>
      <div id="box2" class="p2">最低系统要求</div>
      <div class="p3">硬件必须满足一定的要求才能运行 exchaind。 </div>
      <div class="p3">运行最新版本的 MacOSX、Windows 或 Linux 的台式机或笔记本电脑硬件。 </div>
      <div class="p3">500GB 可用磁盘空间，以 100MB/s 的最低读/写速度访问。 </div>
      <div class="p3">8 个 CPU 内核和 16GB 内存 (RAM)。  </div>
      <div class="p3">上传/下载速度至少为每秒 10 兆字节的宽带互联网连接 。  </div>
      <div id="box3" class="p2">设置新节点</div>
      <div class="p3">这些说明用于从头开始设置全新的完整节点。以下目录是在 root 账号权限下的目录，其它账号用户需要更改相应的目录。 </div>
      <div class="p3">Linux 和 mac 系统 需要给 exchaind 和 exchaincli 增减权限 </div>
      <div class="p3">chmod 777 exchaind</div>
      <div class="p3">chmod 777 exchaincli</div>
      <div class="p3">同时设置全局可以运行，在 exchaind 和 exchaincli 所在目录运行以下命令进行文件所在目 录移动。 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">mv exchaind /usr/bin</div>
        </div>
      </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">mv exchaincli /usr/bin</div>
        </div>
      </div>
      <div class="p3">首先，初始化节点并创建必要的配置文件： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaind init < your_custom_moniker >--chain-idfilechain-778787 </div>
        </div>
      </div>
      <div class="p3">示例：exchaind init aabb--chain-id filechain-778787 </div>
      <div class="p3">注意：名字对象只能包含 ASCII 字符。使用 Unicode 字符将使您的节点无法访问。 </div>
      <div class="p3">您可以 moniker 稍后在~/.exchaind/config/config.toml 文件中编辑它： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># A custom human readable name for this node </div>
          <div style="padding:5px 0">moniker="< your_custom_moniker >" </div>
        </div>
      </div>
      <div class="p3">您可以编辑该~/.exchaind/config/exchaind.toml 文件以启用反垃圾邮件机制并拒绝低于最低 gasPrice 的传入交易： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># This is a TOML config file.#For more information,see https://github.com/toml-lang/toml </div>
          <div style="padding:5px 0">##### main base config options #####  </div>
          <div style="padding:5px 0"># The minimum gas prices a validator is willing to accept for processing a# transaction. A transaction's fees must meet the minimum of any denomination# specified in this config (Our recommendedquantityis 10^-9fax).   </div>
          <div style="padding:5px 0">minimum-gas-prices=""   </div>
        </div>
      </div>
      <div class="p3">您的全节点已初始化！ </div>
      <div id="box4" class="p2">创世种子</div>
      <div class="p3">将 testnet 的 genesis.json 文件提取到.exchaind/config 目录中。</div>
      <div class="p3">linux 在$HOME/.exchaind/config </div>
      <div class="p3">windows 在运行命令的目录 盘符:/.exchaind/config(盘符为在上一步初始化节点的盘符) 。</div>
      <div id="box5" class="p2">添加种子节点</div>
      <div class="p3">您 的 节点 需 要 知道 如 何 找到 对 等 点 。您 需 要 将健 康 的 种 子节 点 添 加到 linux 在 $HOME/.exchaind/config/config.toml 目录 ,windows 在盘符:/.exchaind/config 目录 您可以在~/.exchaind/config/config.toml 文件中 173 行修改为： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0;word-break:break-all"># Comma separated list of seed nodes to connect to seeds="0707b57561b45e6f4404377d7eabce9647193b74@47.242.252.117:26656,f6e99dacd217bc4c452a7cb022959a7a3a58e345@52.53.162.57:26656,d26da33253e82e229e7d0558d90e20132907c888@8.210.149.246:26656,dec7c0b6e264392389346f954a9a5f846a14ecf5@18.144.82.114:26656,ce4f5332fba9b71c0c2ddbab7d7e873f934e1d36@8.210.62.91:26656,96fc31ee23aa4bd3b59d8cbf41a05219dd5c475f@18.144.83.124:26656" </div>
        </div>
      </div>
      <div class="p4">启动一个新节点</div>
      <div class="p3">使用以下命令启动完整节点： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">Windows ：exchaind start--chain-id filechain-778787</div>
        </div>
      </div>
      <div class="p3">如果没有移动 exchaind 到 Linux 下的/usr/bin 目录需要找到程序所在目录运行： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">./exchaind start--chain-id filechain-778787</div>
        </div>
      </div>
      <div class="p3">如果已经移动 exchaind 到 Linux 下的/usr/bin 目录：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaindstart--chain-id filechain-778787</div>
        </div>
      </div>
      <div id="box6" class="p2">客户端使用</div>
      <div class="p4">创建账户</div>
      <div class="p3">要创建一个帐户，您只需要 exchaincli 安装。在创建它之前，您需要知道您打算在哪里存储 并与您的私钥交互。最好的选择是将它们存储在离线专用计算机或硬件钱包中。将它们存储 在您的常规在线计算机上会带来更大的风险，因为通过互联网渗透到您计算机的任何人都可 能泄露您的私钥并窃取您的资金。 </div>
      <div class="p3">要生成帐户，只需使用以下命令： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli keys add < yourKeyName >  </div>
        </div>
      </div>
      <div class="p3">该命令会生成一个 12 字的助记词，同时保存账户的私钥和公钥 0。每次您要发送交易时， 都需要解锁系统的凭证存储。如果您无法访问凭证存储，您始终可以使用助记符恢复私钥。</div>
      <div class="p3">注意： 您可能不需要在每次发送交易时都提供密码，因为大多数操作系统默认会在登录时解锁用户 的凭据。如果您想更改您的凭据安全策略，请参阅您的操作系统手册。 不要丢失或与任何人分享您的12个单词。为防止资金被盗或丢失，最好确保您保留多份助记词，并将其存放 在安全、可靠且只有您知道如何访问的地方。如果有人能够访问您的助记词，他们将能够访问您的私钥并控制与他们关联的帐户 。</div>
      <div class="p4">设置 exchaincli</div>
      <div class="p3">在设置之前 exchaincli，请确保您已经设置了 exchaind。 exchaincli 是使您能够与在 fax 网络上运行的节点进行交互的工具. 为了设置 exchaincli，请使用以下命令： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli config < flag > < value >  </div>
        </div>
      </div>
      <div class="p3">它允许您为每个给定标志设置默认值。 首先，设置要连接的全节点地址： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli config node < host > : < port >  </div>
        </div>
      </div>
      <div class="p3">示例:exchaincliconfignodetcp://localhost:26657 </div>
      <div class="p3">如果您运行自己的全节点，只需 tcp://localhost:26657 用作地址。 然后，设置--trustnode 标志的默认值： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli config trust-node false </div>
        </div>
      </div>
      <div class="p3">如果运行轻型客户端节点，则设置为 true，否则设置为 false 最后，设置 chain-id 要与之交互的区块链：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli config chain-id filechain-778787</div>
        </div>
      </div>
      <div class="p3">检查一切是否运行顺利： </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli status</div>
        </div>
      </div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">支持的平台</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">最低系统要求</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">设置新节点</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">创世种子</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">添加种子节点</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">客户端使用</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">{{$t('m.Compliance')}}</a></p>
        <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">Support for Private Blockchains</a></p>
        <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Separation of Concerns</a></p>
        <p @click="activeted(5)" class="s2"><a :class="{active:flag==5}" href="#box5">Application-Specific Requirements</a></p>

      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaxchainPlatformOverview',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all

</style>